import React, { useState, useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Select from 'material/Select'
import MultiSelectChips from 'material/MultiSelectChips'
import { selectState, isInUnitedStates } from 'store/college'
import { getSegmentValue } from 'components/SegmentSelector/segment-service'
import { withContext } from '../Context'
import { ALL_STATES, getAppropriateOptionType, INDIVIDUAL_TYPE, OPTIONS, getOptions } from './state-service'

export const SegmentName = 'USAState'

export const StateSelector = ({ criteria, segment, collegeState, onChange, isInUnitedStates }) => {
  const currentValue = getSegmentValue(segment, criteria, SegmentName)
  const initialType = useMemo(() => getAppropriateOptionType(currentValue, collegeState), [currentValue, collegeState])
  const [type, setType] = useState(initialType)
  const change = useCallback((value) => onChange(criteria, SegmentName, value), [criteria, onChange])

  const setSelectionType = (type) => {
    change(OPTIONS[type].getDefaultValue(collegeState))
    setType(type)
  }
  const typeOptions = getOptions(isInUnitedStates)

  return (
    <>
      <div>
        <Select
          id="segmentation-state-type-selector"
          label="Student High School State"
          value={type === 'all' ? '' : type}
          options={typeOptions}
          onChange={setSelectionType}
        />
      </div>
      <div>
        {type === INDIVIDUAL_TYPE && (
          <MultiSelectChips
            value={currentValue}
            id="segmentation-state-multi-selector"
            label="Selected States"
            options={ALL_STATES}
            onChange={change}
          />
        )}
      </div>
    </>
  )
}

StateSelector.propTypes = {
  criteria: PropTypes.string.isRequired,
  segment: PropTypes.object,
  isInUnitedStates: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  collegeState: PropTypes.string.isRequired,
}

StateSelector.defaultProps = {
  criteria: 'Must',
  isInUnitedStates: false,
}

export const ConnectedStateSelector = connect((store) => ({
  collegeState: selectState(store),
  isInUnitedStates: isInUnitedStates(store),
}))(StateSelector)

export default withContext(ConnectedStateSelector)
